// mantine
import { UnstyledButton } from '@mantine/core';
// icons
import { Code } from 'lucide-react';
// utils
import useAnalyticsStore from '@/modules/Analytics/Analytics.store.ts';
// assets
import styles from '@/modules/Analytics/components/AnalyticsTrigger/AnalyticsTrigger.module.css';

const AnalyticsTrigger = () => {
    const toggleAnalytics = useAnalyticsStore((state) => state.toggleAnalytics);
    const isAnalyticsOpened = useAnalyticsStore(
        (state) => state.isAnalyticsOpened
    );
    return (
        <UnstyledButton className={styles.trigger} onClick={toggleAnalytics}>
            <Code />
            {isAnalyticsOpened ? 'Hide Logs' : 'Show Logs'}
        </UnstyledButton>
    );
};

export default AnalyticsTrigger;
